<template>
  <div
    class="flex flex-wrap w-full"
    style="min-height: 100px; max-width: 600px"
  >
    <div
      class="px-8 flex flex-1"
      style="min-width: 48%;"
    >
      <div
        :ref="leftTextRef"
        :class="leftTextClass"
      >
        {{ leftText }}
      </div>
    </div>

    <div
      ref="vertical"
      :style="'width: 2px; background:' + verticalLineBackground"
    ></div>

    <div
      class="px-8 flex flex-1"
      style="min-width: 48%"
    >
      <div
        :ref="rightTextRef"
        :class="rightTextClass"
      >
        {{ rightText }}
      </div>
    </div>
  </div>

</template>

<script>
import { LandingPageConstants } from './LandingPageConstants';

export default {
  name: 'HowItWorksVertical',
  mixins: [LandingPageConstants],

  props: {
    index: {
      type: Number,
      default: 0,
    },
    left: {
      type: Object,
      default: null,
    },
    right: {
      type: Object,
      default: null,
    },
    needVerticalLine: Boolean,
  },

  data() {
    return {
      leftText: this.left.text,
      leftIsTitle: this.left.isTitle,

      rightText: this.right.text,
      rightIsTitle: this.right.isTitle,
    };
  },

  computed: {
    leftTextRef() {
      return this.leftIsTitle ? 'stepTitle' : '';
    },

    rightTextRef() {
      return this.rightIsTitle ? 'stepTitle' : '';
    },

    leftTextClass() {
      if (this.leftIsTitle) {
        return 'stepTitle';
      }
      return '';
    },

    rightTextClass() {
      if (this.rightIsTitle) {
        return 'stepTitle';
      }
      return '';
    },

    verticalLineBackground() {
      let color = 'transparent';
      if (this.needVerticalLine) {
        color = '#bac2cc';
      }
      return color;
    },
  },

  methods: {
    setColors(windowPresentYPos) {
      if (!this.needVerticalLine) {
        return;
      }

      let title = this.$refs['stepTitle'];
      let vertical = this.$refs['vertical'];
      const verticalTop =
        vertical.offsetTop - this.VIRTUAL_DIFFERENCE_FOR_STEP_POINTS;
      const fullHeight = vertical.offsetHeight - 1;
      const verticalBot = verticalTop + fullHeight;
      let startPos = verticalTop;
      let endPos = windowPresentYPos + this.MAX_DELTA_BETWEEN_GOLD_AND_GRAY;

      vertical.innerHTML = '';

      if (verticalBot < windowPresentYPos) {
        const el = document.createElement('div');
        el.style.height = fullHeight + 'px';
        el.style.background = this.getRGB(this.GOLD_COLOR);
        vertical.appendChild(el);
        title.style.color = this.getRGB(this.GOLD_COLOR);
        return;
      }

      if (verticalTop > endPos) {
        const el = document.createElement('div');
        el.style.height = fullHeight + 'px';
        el.style.background = this.getRGB(this.GRAY_COLOR);
        vertical.appendChild(el);
        title.style.color = this.getRGB(this.GRAY_COLOR);
        return;
      }

      if (verticalTop < windowPresentYPos) {
        let height = windowPresentYPos - verticalTop;
        const el = document.createElement('div');
        el.style.height = height + 'px';
        el.style.background = this.getRGB(this.GOLD_COLOR);
        vertical.appendChild(el);
        startPos = windowPresentYPos;
      }

      if (endPos > verticalBot) {
        endPos = verticalBot;
      }

      let height = endPos - startPos;
      const topColor = this.colorLerp(startPos - windowPresentYPos);
      const botColor = this.colorLerp(endPos - windowPresentYPos);

      const el = document.createElement('div');
      el.style.height = height + 'px';
      el.style.background =
        'linear-gradient(to bottom, ' +
        this.getRGB(topColor) +
        ', ' +
        this.getRGB(botColor);
      vertical.appendChild(el);

      if (endPos < verticalBot) {
        let height = verticalBot - endPos;
        const el = document.createElement('div');
        el.style.height = height + 'px';
        el.style.background = this.getRGB(this.GRAY_COLOR);
        vertical.appendChild(el);
      }

      const deltaY = verticalBot + this.STEP_POINT_RADIUS - windowPresentYPos;
      let titleColor = this.colorLerp(deltaY);
      title.style.color = this.getRGB(titleColor);
    },
  },
};
</script>
